const buildIcon          = require("Scripts/common/build-icon");
const CompetitionService = require("Scripts/gayl/competition-service");

module.exports = CompetitionEntryForm;

function CompetitionEntryForm(competitionService) {
	var self = this;

	this.competitionService = new CompetitionService;

	this.ui = {
		loader: $('.js-competition-entry-loader'),
		entry: {
			form: $('.js-competition-entry-form'),
			submit: $('.js-submit'),
			message: $('.js-competition-entry-message'),
			success: $('.js-competition-entry-success')
		}
	};

	this.bindEventHandlers = function() {
		this.ui.entry.form.on('submit', this.onSubmit.bind(this));
	};

	this.onSubmit = function(e) {
		console.log("CompetitionEntryForm.onSubmit");

		e.preventDefault();
		this.ui.entry.submit.hide();
		this.ui.loader.show();

		this.competitionService.enter(this.ui.entry.form.serialize())
			.fail(function(err) {
				console.log("Fail");
				// This happens when our controller returns a non 4xx status, meaning the request was invalid, or the endpoint doesn't exist.
				self.displayError("Unable to enter at this moment, please try again.");
			}).then(function (resp) {
				console.log("Then");
				if(resp && resp.success) {
					self.ui.entry.form.hide();
					self.ui.entry.success.collapse('show');
				} else {
					self.displayError(resp.payload.error);
				}
			}).always(function() {
				console.log("Always");
				self.ui.entry.submit.show();
				self.ui.loader.hide();
			});
	};

	this.displayError = function(message) {
		this.ui.entry.message.empty();
		this.ui.entry.message.collapse("show");
		this.ui.entry.message.html('<div class="alert alert-red mt-3">' + buildIcon('fa-circle-xmark') + ' ' + message + '</div>');
	};

	this.displaySuccess = function(message) {
		this.ui.entry.message.empty();
		this.ui.entry.message.collapse("show");
		this.ui.entry.message.html('<div class="alert alert-green">' + message + '</div>');
	};

	this.bindEventHandlers();
}